import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsStickyNavSection from '../enums/TrailDetailsStickyNavSection';

type logTrailDetailsStickyNavClickedParams = {
  current_nav_section?: TrailDetailsStickyNavSection;
  section_clicked?: TrailDetailsStickyNavSection;
  trail_id?: number;
};

/**
 * User taps a link in the floating sticky nav on the web trail page.
 * @param params - Attributes to log with the amplitude event
 * @param params.current_nav_section - The section of the page that the user was in when they clicked the sticky nav.
 * @param params.section_clicked - The link in the sticky nav that the user clicked.
 * @param params.trail_id - The trail page the user was on when they tapped a link to complete an action.
 */
const logTrailDetailsStickyNavClicked = (
  { current_nav_section, section_clicked, trail_id }: logTrailDetailsStickyNavClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details sticky nav clicked',
    { 'current nav section': current_nav_section, 'section clicked': section_clicked, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsStickyNavClicked;
